/**
 * 下载一张图片
 * @param _url 图片地址
 */
export function loadImg(_url: string) {
    let a = document.createElement('a');
    a.href = _url;
    a.download = '体验二维码.jpg';
    a.click();
}